import { render } from "./SidebarInner.vue?vue&type=template&id=79be70f0&scoped=true"
import script from "./SidebarInner.vue?vue&type=script&lang=js"
export * from "./SidebarInner.vue?vue&type=script&lang=js"

import "./SidebarInner.vue?vue&type=style&index=0&id=79be70f0&lang=scss&scoped=true"

import exportComponent from "/home/daniel/code/myawu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79be70f0"]])

export default __exports__